import { render, staticRenderFns } from "./v-navbar-menu-item.vue?vue&type=template&id=0a0ac22e&scoped=true&"
import script from "./v-navbar-menu-item.vue?vue&type=script&lang=js&"
export * from "./v-navbar-menu-item.vue?vue&type=script&lang=js&"
import style0 from "./v-navbar-menu-item.vue?vue&type=style&index=0&id=0a0ac22e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0ac22e",
  null
  
)

export default component.exports